"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const healthBannerInputs = [
  {
    name: "content",
    type: "richText",
    required: true,
    defaultValue: "18+. THESE PRODUCTS ARE NOT RISK-FREE AND ARE ADDICTIVE",
  },
  {
    name: "variant",
    type: "string",
    enum: ["default", "strong", "stronger", "custom"],
    required: true,
    defaultValue: "strong",
  },
  {
    name: "customProperties",
    type: "object",
    showIf: `options.get("variant") === "custom"`,
    subFields: [
      {
        name: "backgroundColor",
        type: "color",
      },
      {
        name: "borderColor",
        type: "color",
      },
      {
        name: "borderWidth",
        type: "string",
      },
      {
        name: "fontFamily",
        type: "string",
        enum: [
          { label: "Default", value: "" },
          { label: "Arial", value: "arial" },
          { label: "Helvetica", value: "helvetica" },
          { label: "Helvetica Black", value: "Helvetica Neue" },
        ],
      },
      {
        name: "fontSize",
        type: "string",
      },
      {
        name: "textColor",
        type: "color",
      },
      {
        name: "width",
        type: "string",
      },
      {
        name: "height",
        type: "string",
      },
    ],
    defaultValue: {},
  },
] as const satisfies Inputs;

const HealthBanner = dynamic(async () =>
  withValidation(
    healthBannerInputs,
    (await import("./HealthBanner")).HealthBanner,
    "HealthBanner"
  )
);

export const HealthBannerComponent: RegisteredComponent = {
  name: "HealthBanner",
  component: HealthBanner,
  inputs: healthBannerInputs,
};
